angular.module('GlobalHelpersModule').filter "shortDateLocal", ->
  (date) ->
    if date? and date.length > 0 then moment(date).format('MMM D, YYYY') else ""